import React from "react";
import "./home.css"
import { Link } from 'react-router-dom';
import logo from "../../images/logo.png"
import CityScape from "../../images/city-scape.jpg"
import Social from "../../components/social";

export default function Home(){
    return(
        <>
            <div className="triangle"></div>
            <img src={CityScape} alt="city scape" className="home-image"></img>
                <div className="home">
                    <div className="home-title-container">
                        <h1 className="home-title">COLORANTÍ </h1>
                        <img src={logo} alt="colorantí logo" className="home-logo"/>
                    </div>
                    <div className="home-container">
                        <div className="inner">
                            <h1 className="home-title-2">MORALLY CODED TECHNICALLY SOUND ENCRYPTING THE WORLD <br></br> THROUGH COLOR</h1>                        
                        </div>
                    </div>
                        <nav className="home-nav">
                            <a href="https://colorantiteam.com/" className="home-nav-child">WHO WE ARE</a>
                            <Link to="/Demo" className="home-nav-child">HOW IT WORKS</Link>
                            <a href="https://linktr.ee/coloranti" rel="noreferrer" className="home-nav-child" target="_blank">CONTACT US</a>
                        </nav>
                    
                </div>
        </>
    )
}